/**
 * HelpBot Prompts
 *
 * Centralized prompts for triggering HelpBot assistance throughout the app.
 * Use these with the HelpBotPromptButton component or directly via useHelpBotContext().sendPrompt()
 */

export const HELP_BOT_PROMPTS = {
    // General
    WHAT_CAN_I_DO: 'What can I do with Scoop?',
    GETTING_STARTED: 'How do I get started with Scoop?',

    // Data Sources
    CONNECT_DATA_SOURCE: 'How do I connect a new data source?',
    HUBSPOT_SETUP: 'How do I set up churn analysis with HubSpot data?',
    CLOSE_CRM_SETUP: 'Walk me through connecting Close CRM',
    GOOGLE_ADS_ROI: 'How do I measure marketing ROI with Google Ads data?',
    MULTIPLE_SOURCES: 'How do I connect and analyze data from multiple sources?',

    // Analysis / Explorer
    EXPLORER_SCREEN: 'What can I do on the Explorer screen?',
    CUSTOMER_JOURNEY: "How do I track a customer's full journey across my tools?",
    CREATE_CHART: 'How do I create a chart?',
    CREATE_METRIC: 'How do I create a metric?',
    FILTER_DATA: 'How do I filter my data?',

    // Live Query
    LIVE_QUERY_SCREEN: 'What can I do on the Live Query screen?',

    // Live Worksheets
    LIVE_WORKSHEETS_SCREEN: 'What can I do on the Live Worksheets screen?',

    // Canvas
    CANVAS_SCREEN: 'What can I do on the Canvases screen?',
    ADD_VISUALIZATION: 'How do I add a visualization to my canvas?',
    SHARE_CANVAS: 'How do I share a canvas with my team?',

    // Datasets
    DATASET_SCREEN: 'What can I do on the Datasets screen?',
    UPLOAD_DATA: 'How do I upload my own data?',
    EDIT_DATASET: 'How can I edit my dataset?',
    REFRESH_DATA: 'How do I refresh my data?',

    // Collaboration
    INVITE_TEAM: 'How do I invite team members to my workspace?',
    SHARE_INSIGHTS: 'How can I share insights with my team?',
}

/**
 * Contextual nudge prompts mapped to routes
 * Each route can have a nudge that appears near the HelpBot FAB
 */
export const HELP_BOT_NUDGE_PROMPTS = {
    '/explorer': {
        message: 'Need help exploring your data?',
        prompt: HELP_BOT_PROMPTS.EXPLORER_SCREEN,
    },
    '/canvas': {
        message: 'Want tips for building your canvas?',
        prompt: HELP_BOT_PROMPTS.CANVAS_SCREEN,
    },
    '/sources': {
        message: 'Need help connecting a data source?',
        prompt: HELP_BOT_PROMPTS.CONNECT_DATA_SOURCE,
    },
    '/live-worksheets': {
        message: 'Learn what you can do with Live Worksheets',
        prompt: HELP_BOT_PROMPTS.LIVE_WORKSHEETS_SCREEN,
    },
    '/insights': {
        message: 'Want help analyzing your data?',
        prompt: HELP_BOT_PROMPTS.CREATE_CHART,
    },
    '/live-query': {
        message: 'Need help with Live Query?',
        prompt: HELP_BOT_PROMPTS.LIVE_QUERY_SCREEN,
    },
    '/onboarding': {
        message: 'Need guidance getting started?',
        prompt: HELP_BOT_PROMPTS.GETTING_STARTED,
    },
}
